<template>
  <el-table
    :data="countTable"
    border
    style="width: 100%"
    :maxHeight="maxHeight"
    :span-method="objectSpanMethod"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      v-if="dataType == 'sku'"
      prop="skuId"
      label=" SKU id"
      width="180"
      align="center"
    >
    </el-table-column>
    <el-table-column
      v-if="dataType == 'spu'"
      prop="numiid"
      label="商品id"
      width="180"
      align="center"
    >
    </el-table-column>
    <el-table-column
      v-if="dataType == 'sku' || dataType == 'spu'"
      prop="title"
      label="商品标题"
      width="180"
      align="center"
    >
      <template slot-scope="{ row }">
        <textOverflowTooltip :content="row.title" :lines="1" :isCenter="true"/>
      </template>
    </el-table-column>
    <el-table-column
      v-if="dataType == 'sku' || dataType == 'spu'"
      prop="platformCategory"
      label="平台类目"
      width="200"
      align="center"
    >
      <template slot-scope="{ row }">
        <textOverflowTooltip :content="row.platformCategory" :lines="1" />
      </template>
    </el-table-column>
    <template v-if="dataType == 'category' || dataType == 'sellerCategory' || dataType == 'customCategory'">
      <el-table-column
        :key="'category_' + index"
        :label="item.label"
        :prop="item.prop"
        v-for="(item, index) in categoryList"
        :label-class-name="item.labelColor ? item.labelColor : ''"
        :align="item.align ? item.align : 'center'"
      >
        <el-table-column
          :prop="childrenItem.prop"
          :label="childrenItem.label"
          :min-width="childrenItem.width ? childrenItem.width : '80'"
          fixed
          v-for="(childrenItem, childrenIndex) in item.childrenProps"
          :key="childrenItem.label + childrenIndex"
          :label-class-name="item.labelColor ? item.labelColor : ''"
          :align="childrenItem.align ? childrenItem.align : 'center'"
        >
          <template slot-scope="{ row }">
            <div class="flex-y-c">
              <textOverflowTooltip
                :content="row[childrenItem.prop]"
                :lines="2"
              />
            </div>
          </template>
        </el-table-column>
      </el-table-column>
    </template>
    <template v-if="dataType == 'itemTag'">
      <template v-if="preCascadeItemTagClassifyType == 0">
        <el-table-column
          label="商品标签"
          align="center"
        >
          <el-table-column
            prop="classifyName"
            label="标签分类"
            width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="title"
            label="标签名称"
            width="180"
            align="center"
          >
            <template slot-scope="{ row }">
              <textOverflowTooltip :content="row.title" :lines="1" :isCenter="true"/>
            </template>
          </el-table-column>
        </el-table-column>
      </template>
      <template v-else-if="preCascadeItemTagClassifyType == 1">
        <el-table-column
          :key="'category_' + index"
          :label="item.label"
          :prop="item.prop"
          v-for="(item, index) in categoryList"
          :label-class-name="item.labelColor ? item.labelColor : ''"
          :align="item.align ? item.align : 'center'"
        >
          <el-table-column
            :prop="childrenItem.prop"
            :label="childrenItem.label"
            :min-width="childrenItem.width ? childrenItem.width : '80'"
            v-for="(childrenItem, childrenIndex) in item.childrenProps"
            :key="childrenItem.label + childrenIndex"
            :label-class-name="item.labelColor ? item.labelColor : ''"
            :align="childrenItem.align ? childrenItem.align : 'center'"
          >
            <template slot-scope="{ row }">
              <textOverflowTooltip :content="row[childrenItem.prop]" :lines="2" />
            </template>
          </el-table-column>
        </el-table-column>
      </template>
    </template>
    <el-table-column
      prop="payCount"
      sortable
      width="120"
      label="付款人数"
      align="right"
    >
    </el-table-column>
    <el-table-column
      prop="tradeAmount"
      sortable
      label="付款金额"
      align="right"
      width="120"
    >
    </el-table-column>
    <el-table-column
      prop="tradeAmountRatio"
      sortable
      label="金额占比"
      align="right"
      width="120"
    >
    </el-table-column>
    <el-table-column
      prop="payTimes"
      sortable
      label="付款单量"
      align="right"
      width="120"
    >
    </el-table-column>
    <el-table-column
      prop="payNum"
      sortable
      label="付款件数"
      align="right"
      width="120"
    >
    </el-table-column>
    <el-table-column
      prop="payAvgAmount"
      sortable
      label="客单价"
      align="right"
      width="120"
    >
    </el-table-column>
    <el-table-column
      v-if="reportParams.measureUnitId"
      prop="measureUnitSum"
      sortable
      :label="reportParams.measureUnitName + '数'"
      align="right"
      width="120"
    >
    </el-table-column>
    <el-table-column
      :key="index"
      :label="item.label"
      :prop="item.prop"
      v-for="(item, index) in tabledataList"
      :label-class-name="item.labelColor ? item.labelColor : ''"
      :align="item.align ? item.align : 'center'"
    >
      <el-table-column
        :prop="childrenItem.prop"
        :label="childrenItem.label"
        :min-width="childrenItem.width ? childrenItem.width : '140'"
        fixed
        v-for="(childrenItem, childrenIndex) in item.childrenProps"
        :key="childrenItem.label + childrenIndex"
        :label-class-name="item.labelColor ? item.labelColor : ''"
        :align="childrenItem.align ? childrenItem.align : 'right'"
      >
        <template slot-scope="{ row }">
          <span>{{ row[childrenItem.prop] }}</span>
        </template>
      </el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
import Empty from "../../../components/empty.vue";
import mixins from "../../../mixins/index.js";

export default {
  name: "marketAnalysisCom",
  mixins: [mixins],
  components: {
    Empty,
    textOverflowTooltip: () =>
      import(
        "@/components/ai/components/prefabricateReport/components/textOverflowTooltip.vue"
      ),
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
    dataType: {
      type: String,
      default: "sku",
    },
    reportParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      maxCategoryLevel: 0,
      visibleCategoryLevel: 1,
      countTable: [],
      spanObj: {},
      spanObj_1: {},
    };
  },
  computed: {
    prevReportView() {
      if (this.dataType != 'itemTag') {
        return this.reportParams.reportView || 0;
      } else {
        return this.reportParams.reportView != null && this.reportParams.reportView !== ''
               ? this.reportParams.reportView
               : 1;
      }
    },
    preCascadeItemTagClassifyType() {
      return this.reportParams.cascadeItemTagClassifyType || 0;
    },
    preCascadeItemTagClassifyNameList() {
      return this.reportParams.cascadeItemTagClassifyNameList ? [ ...this.reportParams.cascadeItemTagClassifyNameList ] : [];
    },
    categoryList() {
      const levels = [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
      ];
      const childrenProps = [];
      const len =
        this.visibleCategoryLevel > 0
          ? this.visibleCategoryLevel
          : this.maxCategoryLevel > 0
          ? 1
          : 0;
      for (let i = 0; i < len; i++) {
        childrenProps.push({
          prop: `categoryName_${i}`,
          label:
            (this.dataType == "itemTag" &&
             this.preCascadeItemTagClassifyType == 1 &&
             this.preCascadeItemTagClassifyNameList[i])
              ? this.preCascadeItemTagClassifyNameList[i]
              : `${levels[i] || i + 1}级类目`,
          width: "180",
          levelIndex: i,
        });
      }
      if (childrenProps.length === 0 && this.maxCategoryLevel === 0) {
        childrenProps.push({
          prop: `categoryName_0`,
          label: `一级类目`,
          width: "180",
          levelIndex: 0,
        });
      }
      return [
        {
          label: this.dataType == 'itemTag' ? "商品标签" : this.dataType == "category" ? "平台类目" : this.dataType == "customCategory" ? "自定义类目" : "店铺类目",
          childrenProps: childrenProps,
        },
      ];
    },
    tabledataList() {
      let arr = [
        // 当前
        {
          label: "新客",
          childrenProps: [
            {
              prop: "newBuyerReport_payCount",
              label: "付款人数",
              align: "right",
            },
            {
              prop: "newBuyerReport_tradeAmount",
              label: "付款金额",
              align: "right",
            },
            {
              prop: "newBuyerReport_tradeAmountRatio",
              label: "金额占比",
              align: "right",
            },
            {
              prop: "newBuyerReport_payTimes",
              label: "付款单量",
              align: "right",
            },
            {
              prop: "newBuyerReport_payNum",
              label: "付款件数",
              align: "right",
            },
            {
              prop: "newBuyerReport_payAvgAmount",
              label: "客单价",
              align: "right",
            },
            {
              prop: "newBuyerReport_payCountRatio",
              label: "新客占比",
              align: "right",
            },
          ],
        },
        {
          label: "老客",
          childrenProps: [
            {
              prop: "oldBuyerReport_payCount",
              label: "付款人数",
              align: "right",
            },
            {
              prop: "oldBuyerReport_tradeAmount",
              label: "付款金额",
              align: "right",
            },
            {
              prop: "oldBuyerReport_tradeAmountRatio",
              label: "金额占比",
              align: "right",
            },
            {
              prop: "oldBuyerReport_payTimes",
              label: "付款单量",
              align: "right",
            },
            {
              prop: "oldBuyerReport_payNum",
              label: "付款件数",
              align: "right",
            },
            {
              prop: "oldBuyerReport_payAvgAmount",
              label: "客单价",
              align: "right",
            },
            {
              prop: "oldBuyerReport_payCountRatio",
              label: "老客占比",
              align: "right",
            },
          ],
          labelColor: "active-color",
        },
        {
          label: "会员",
          childrenProps: [
            {
              prop: "memberReport_payCount",
              label: "付款人数",
              align: "right",
            },
            {
              prop: "memberReport_tradeAmount",
              label: "付款金额",
              align: "right",
            },
            {
              prop: "memberReport_tradeAmountRatio",
              label: "金额占比",
              align: "right",
            },
            {
              prop: "memberReport_payTimes",
              label: "付款单量",
              align: "right",
            },
            {
              prop: "memberReport_payNum",
              label: "付款件数",
              align: "right",
            },
            {
              prop: "memberReport_payAvgAmount",
              label: "客单价",
              align: "right",
            },
            {
              prop: "memberReport_payCountRatio",
              label: "会员占比",
              align: "right",
            },
          ],
          slot: true,
        },
        {
          label: "会员新客",
          childrenProps: [
            {
              prop: "newMemberReport_payCount",
              label: "付款人数",
              align: "right",
            },
            {
              prop: "newMemberReport_tradeAmount",
              label: "付款金额",
              align: "right",
            },
            {
              prop: "newMemberReport_tradeAmountRatio",
              label: "金额占比",
              align: "right",
            },
            {
              prop: "newMemberReport_payTimes",
              label: "付款单量",
              align: "right",
            },
            {
              prop: "newMemberReport_payNum",
              label: "付款件数",
              align: "right",
            },
            {
              prop: "newMemberReport_payAvgAmount",
              label: "客单价",
              align: "right",
            },
            {
              prop: "newMemberReport_payCountRatio",
              label: "新客占比",
              align: "right",
            },
          ],
          slot: true,
        },
        {
          label: "会员老客",
          childrenProps: [
            {
              prop: "oldMemberReport_payCount",
              label: "付款人数",
              align: "right",
            },
            {
              prop: "oldMemberReport_tradeAmount",
              label: "付款金额",
              align: "right",
            },
            {
              prop: "oldMemberReport_tradeAmountRatio",
              label: "金额占比",
              align: "right",
            },
            {
              prop: "oldMemberReport_payTimes",
              label: "付款单量",
              align: "right",
            },
            {
              prop: "oldMemberReport_payNum",
              label: "付款件数",
              align: "right",
            },
            {
              prop: "oldMemberReport_payAvgAmount",
              label: "客单价",
              align: "right",
            },
            {
              prop: "oldMemberReport_payCountRatio",
              label: "老客占比",
              align: "right",
            },
          ],
          slot: true,
        },
        {
          label: "非会员",
          childrenProps: [
            {
              prop: "nonMemberReport_payCount",
              label: "付款人数",
              align: "right",
            },
            {
              prop: "nonMemberReport_tradeAmount",
              label: "付款金额",
              align: "right",
            },
            {
              prop: "nonMemberReport_tradeAmountRatio",
              label: "金额占比",
              align: "right",
            },
            {
              prop: "nonMemberReport_payTimes",
              label: "付款单量",
              align: "right",
            },
            {
              prop: "nonMemberReport_payNum",
              label: "付款件数",
              align: "right",
            },
            {
              prop: "nonMemberReport_payAvgAmount",
              label: "客单价",
              align: "right",
            },
            {
              prop: "nonMemberReport_payCountRatio",
              label: "非会员占比",
              align: "right",
            },
          ],
          slot: true,
        },
      ];
      if(this.reportParams.measureUnitId){
        const reportKeys = [
          "newBuyerReport",
          "oldBuyerReport",
          "memberReport",
          "newMemberReport",
          "oldMemberReport",
          "nonMemberReport",
        ];
        arr.forEach((item, index) => {
            item.childrenProps.push({
              prop: reportKeys[index] + "_measureUnitSum",
              label: this.reportParams.measureUnitName + '数',
              align: "right",
            })
        })
      }
      return arr;
    },
  },
  watch: {
    tableData: {
      handler(newVal) {
        if (newVal) {
          let maxLevel = 0;
          let tableList = newVal.map((item) => {
            let obj = {
              skuId: item.skuId,
              numiid: item.numiid,
              title: item.title,
              classifyId: item.classifyId,
              classifyName: item.classifyName,
              platformCategory: item.platformCategory,
              ...item.totalPayReport,
            };
            if (item.categoryNameList && item.categoryNameList.length > 0) {
              if (item.categoryNameList.length > maxLevel) {
                maxLevel = item.categoryNameList.length;
              }
              item.categoryNameList.forEach((catName, idx) => {
                obj[`categoryName_${idx}`] = catName;
              });
            }
            const reportKeys = [
              "newBuyerReport",
              "oldBuyerReport",
              "memberReport",
              "newMemberReport",
              "oldMemberReport",
              "nonMemberReport",
            ];
            reportKeys.forEach((key) => {
              if (item[key]) {
                for (let subKey in item[key]) {
                  obj[`${key}_${subKey}`] = item[key][subKey];
                }
              }
            });
            return obj;
          });
          this.maxCategoryLevel = maxLevel;
          this.visibleCategoryLevel = maxLevel;
          this.countTable = Object.freeze(tableList.map((row) => {
            const newRow = {};
            Object.keys(row).forEach((key) => {
              // 不需要处理得字段直接返回
              if (
                key === "skuId" ||
                key === "numiid" ||
                key === "title" ||
                key === "classifyId" ||
                key === "classifyName" ||
                key === "platformCategory" ||
                key.startsWith("categoryName_")
              ) {
                newRow[key] = row[key];
                return;
              }
              if (key.includes("Ratio")) {
                newRow[key] = this.formatPercent(row[key]);
              } else {
                newRow[key] = this.formatNumber(row[key]);
              }
            });
            return newRow;
          }));
          if (
            this.dataType === "category" ||
            this.dataType === "sellerCategory" ||
            this.dataType === "customCategory" ||
            (this.dataType == 'itemTag' && this.prevReportView == 1 && this.preCascadeItemTagClassifyType == 1)
          ) {
            this.getSpanData(this.countTable);
          }
          if (this.dataType == 'itemTag' && this.prevReportView == 1 && this.preCascadeItemTagClassifyType == 0) {
            this.getSpanData_1(this.countTable);
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    getSpanData(data) {
      this.spanObj = {};
      if (!data || data.length === 0) return;
      for (let i = 0; i < this.maxCategoryLevel; i++) {
        let prop = `categoryName_${i}`;
        this.spanObj[prop] = [];
        let position = 0;
        data.forEach((item, index) => {
          if (index === 0) {
            this.spanObj[prop].push(1);
            position = 0;
          } else {
            let isMatch = true;
            // 当前层级及所有父级层级都必须相同才能合并
            for (let j = 0; j <= i; j++) {
              let p = `categoryName_${j}`;
              if (item[p] !== data[index - 1][p]) {
                isMatch = false;
                break;
              }
            }
            if (isMatch) {
              this.spanObj[prop][position] += 1;
              this.spanObj[prop].push(0);
            } else {
              this.spanObj[prop].push(1);
              position = index;
            }
          }
        });
      }
    },
    getSpanData_1(data) {
      this.spanObj_1 = {};
      if (!data || data.length === 0) return;
      this.spanObj_1['classifyName'] = [];
      let position = 0;
      data.forEach((item, index) => {
        if (index === 0) {
          this.spanObj_1['classifyName'].push(1);
          position = 0;
        } else {
          if (item.classifyName == data[index - 1].classifyName) {
            this.spanObj_1['classifyName'][position] += 1;
            this.spanObj_1['classifyName'].push(0);
          } else {
            this.spanObj_1['classifyName'].push(1);
            position = index;
          }
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.dataType == 'itemTag' && this.prevReportView == 0 && rowIndex != 0) {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
      if((this.dataType == 'sku' || this.dataType == 'spu') && rowIndex === 0){
        let props = ['skuId', 'title']
        let isTotal = row[props[0]] == '合计' && row[props[1]] == '合计'
        if(this.dataType == 'spu'){
          props = ['numiid', 'title']
          isTotal = row[props[1]] == '合计'
        }
        if(isTotal){
         if(column.property === props[0]){
          return {
            rowspan: 0,
            colspan: 0
          };
         }
         if(column.property === props[1]){
          return {
            rowspan: 1,
            colspan: 2
          };
         }
        }
      }
      if(this.dataType == 'itemTag' && rowIndex === 0){
        let props = ['classifyName', 'title', 'skuId']
        let isTotal = row[props[1]] == '合计' && row[props[2]] == '合计'
        if(isTotal){
          if(column.property === props[0]){
            return {
              rowspan: 0,
              colspan: 0
            };
          }
          if(column.property === props[1]){
            return {
              rowspan: 1,
              colspan: 2
            };
          }
        }
      }
      if (this.dataType == 'itemTag' && this.prevReportView == 1 && this.preCascadeItemTagClassifyType == 0 && column.property == 'classifyName') {
        const _row = this.spanObj_1[column.property]
          ? this.spanObj_1[column.property][rowIndex]
          : 1;
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (
        (this.dataType === "category" ||
         this.dataType === "sellerCategory" ||
         this.dataType === "customCategory" ||
         (this.dataType == 'itemTag' && this.prevReportView == 1 && this.preCascadeItemTagClassifyType == 1)
        ) &&
          column.property &&
          column.property.startsWith("categoryName_")
      ) {
        const _row = this.spanObj[column.property]
          ? this.spanObj[column.property][rowIndex]
          : 1;
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
  },
};
</script>
